function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import React, { FC, useState, useEffect, useRef, CSSProperties, RefObject, ReactNode, ElementType } from 'react';
import cn from 'classnames';
import { useForkRef } from '../../hooks/useForkRef';
import { getAutoHeightDuration } from '../../_internal_/utils/getAutoHeightDuration';
require("./Collapse.css");
var styles = {
  "Collapse": "Collapse-module-Collapse_lhg"
};
export const Collapse = ({
  children,
  className = '',
  collapsedSize = 0,
  isEnter,
  controlRef,
  innerRef,
  maxSize,
  style,
  tag = 'div',
  ...props
}) => {
  const Component = tag;
  const [height, setHeight] = useState(0);
  const wrapperRef = useRef(null);
  const rootRef = useRef(null);
  const autoTransitionDuration = useRef(0);
  const ownRef = useForkRef(rootRef, innerRef || controlRef);
  useEffect(() => {
    const wrapperHeight = wrapperRef.current ? wrapperRef.current.clientHeight : 0;
    setHeight(wrapperHeight);
    const transitionDuration = getAutoHeightDuration(wrapperHeight);
    autoTransitionDuration.current = transitionDuration;
    const root = rootRef.current;
    if (isEnter) {
      root?.classList.add(`${styles.Collapse}-entered`);
    } else {
      root?.classList.remove(`${styles.Collapse}-entered`);
    }
  }, [isEnter, collapsedSize, children]);
  return /*#__PURE__*/React.createElement(Component, _extends({
    className: cn(styles.Collapse, className),
    ref: ownRef,
    style: {
      ...style,
      ...(maxSize ? {
        maxHeight: maxSize
      } : {}),
      minHeight: collapsedSize,
      overflowY: 'auto',
      transitionDuration: `${autoTransitionDuration.current}ms`,
      height: isEnter ? height : collapsedSize
    }
  }, props), /*#__PURE__*/React.createElement("div", {
    ref: wrapperRef,
    className: "Collapse-Panel"
  }, children));
};
if (process.env.NODE_ENV !== 'production') {
  Collapse.displayName = 'Collapse';
}